import {useSelector} from 'react-redux';

import {applicationsSelector} from 'features/applications/selectors';

import portalAppUrl from 'config/portal';

export const useFirstApplication = () => {
    const applications = useSelector((state) => applicationsSelector(state));

    let application = {
        origin: portalAppUrl,
        pathname: '/',
    };

    if (Array.isArray(applications) && applications.length > 0) {
        //application = applications[0];
        const found = applications.find((item) => item.position === 1);
        if (found) {
            application = found;
        }
    }

    return application;
};
